import React  from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import providerNewsletter from 'assets/provider-newsletter.png';
import providerLocation from 'assets/provider-location-services.png';
import providerSearch from 'assets/provider-search-ndis.png';


const AssetsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  justify-content: space-between;
  height: 100%;
`;


const AssetsStack = () => {

  return (
    <AssetsContainer>
      <Asset
        asset={providerNewsletter}
        title="50,000+ engaged community members"
      />
      <Asset
        asset={providerLocation}
        title="45,000+ active website visitors every month"
      />
      <Asset
        asset={providerSearch}
        title="450,000+ people have used Clickability over 12+ years"
      />
    </AssetsContainer>
  );
};

const AssetContainer = styled.div`
  --size: 220px;
  width: var(--size);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  .title {
    text-align: center;
    font-size: 14px;
    font-weight: 500;
  }
`;

const Asset = ({ asset, title }) => {

  return (
    <AssetContainer>
      <img src={asset} width="160px" alt="asset" />
      <div className="title">
        {title}
      </div>
    </AssetContainer>
  );
};

Asset.propTypes = {
  asset: PropTypes.string,
  title: PropTypes.string,
};


export default AssetsStack;

